import React from "react";
import { HiArrowRight } from "react-icons/hi";
const Packages = () => {
  return (
    <section
      className="relative min-h-[1032px] font-sans px-4 md:px-0 py-4 md:py-8"
      style={{
        background: `
    linear-gradient(
      180deg,
      rgba(201, 245, 103, 0.4) 0%,
      rgba(201, 245, 103, 0.6) 35%,
      rgba(11, 43, 64, 0.7) 60%,
      rgba(11, 43, 64, 0.9) 85%,
      rgba(0, 0, 0, 1) 100%
    )
  `
      }}

    >

      {/* Gradient overlay */}
      {/* <div className="absolute inset-0 bg-black/10"></div> */}

      <div className="relative  mx-auto max-w-6xl  flex flex-col gap-16 py-16" >

        {/* Heading */}
        <div className="flex flex-col gap-4 justify-center items-center text-center text-white">
          <h2 className="text-center h2-mb h2-md h2-lg h2-2xl">
            Reputationsmanagement auf neuem Niveau —
            {" "}
            <span className="text-[#0b2b40]">schnell, kontrolliert, transparent.</span>
          </h2>

          <p className="w-full md:w-[682px] text-gray-900 text-base md:text-lg ">
            Durch unsere umfassende Erfahrung im
            Reputationsmanagement erhalten Sie eine effiziente,
            sichere und langfristig wirksame Lösung zur
            Optimierung lhres Online-Rufs.
          </p>
        </div>

        {/* ===== FEATURES BOX ===== */}
        <div className="flex flex-col gap-10 bg-[#0b2b40] p-6  md:p-[62px] rounded-2xl text-white shadow-xl shadow-black/20">

          {/* FEATURES GRID */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full">

            {/* LEFT COLUMN */}
            <div className="flex flex-col gap-6">
              {[
                {
                  title: "Immer für Sie da:",
                  text: `Löschungen rund um die Uhr — flexibel und ohne Einschränkungen.`,
                },
                {
                  title: "Plattformübergreifend:",
                  text: "Google, GoLocal, Jameda, Kununu und andere.",
                },
                {
                  title: "Fair von Anfang an:",
                  text: "Sie zahlen nur im Erfolgsfall - klar, sicher und ohne versteckte Kosten.",
                },
              ].map((item, idx) => (
                <Feature key={idx} title={item.title} text={item.text} />
              ))}
            </div>

            {/* RIGHT COLUMN */}
            <div className="flex flex-col gap-6">
              {[

                {
                  title: "100 % Transparenz:",
                  text: "Ihr kompletter Fortschritt - jederzeit im Kunden-Center sichtbar.",
                },
                {

                  title: "Spart interne Ressourcen:",
                  text: "Ihr Team wird entlastet und Sie sparen Zeit.",
                },

                {
                  title: "Mehr Sichtbarkeit:",
                  text: "Suchmaschinen verweisen auf die Besten am Markt.",
                },
              ].map((item, idx) => (
                <Feature key={idx} title={item.title} text={item.text} />
              ))}
            </div>
          </div>

          {/* ===== PRICE CARDS ===== */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-10">

            {/* CARD 1 */}
            <PriceCard
              label=" Ab der 5. Löschung"
              price="€89,00"
              per="Pro Löschung "
            />

            {/* CARD 2 - Main card */}
            <PriceCard
              label="Regulärer Preis"
              price="€129,00"
              per="Pro Löschung "
              highlight
            />

            {/* CARD 3 */}
            <PriceCard
              label="ab 10 Löschungen"
              price="€79,00"
              per="Pro Löschung "
            />

          </div>

        </div>
      </div>
    </section>
  );
};

/* FEATURE ITEM */
const Feature = ({ title, text }) => (
  <div className="flex gap-4">
    <div className="flex-shrink-0">
      <svg
        width="28"
        height="28"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M25.4 7.1C30.7 12.4 30.6 21 25.1 26.2C20.1 31 11.9 31 6.8 26.2C1.4 21 1.3 12.4 6.6 7.1C11.8 1.9 20.2 1.9 25.4 7.1Z"
          fill="#16a34a"
        />
        <path
          d="M10.3 16.5L14.1 20.3L21.6 12.7"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </div>
    <div>
      <h5 className="h5-mb h5-md h5-lg h5-2xl !text-white">{title}</h5>
      <p className="text-white/60 text-base md:text-lg">{text}</p>
    </div>
  </div>
);


/* PRICE CARD */
const PriceCard = ({ label, price, per, highlight = false }) => (
  <div
    className={`flex flex-col items-center text-center p-4 rounded-2xl border
    ${highlight
        ? "bg-[linear-gradient(to_bottom,_#fff_33%,_#91c4c7)] text-black border-gray-200 shadow-2xl scale-[1.02]"
        : "bg-[linear-gradient(180deg,_#0b2b40_25%,_rgba(0,33,33,0)_100%),_linear-gradient(180deg,_hsla(0,0%,100%,0.35)_33%,_#91c4c7)] border-[#1b4446] text-white"
      }
  `}
  >

    <p
      className={`text-sm font-medium flex  mb-4 py-1 gap-2 px-2 rounded-full 
      ${highlight ? "border rounded-full border-white-600 text-[#1d4f4e]" : "border rounded-full border-white text-white/80"}`}
    >
      <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="presentation"><path d="M3.53906 7.18455C3.41743 6.63666 3.4361 6.06692 3.59336 5.52817C3.75061 4.98942 4.04135 4.49909 4.43862 4.10266C4.83588 3.70622 5.32682 3.41651 5.8659 3.26038C6.40498 3.10426 6.97475 3.08677 7.52239 3.20955C7.82382 2.73814 8.23906 2.35019 8.72985 2.08146C9.22064 1.81273 9.77118 1.67187 10.3307 1.67188C10.8903 1.67187 11.4408 1.81273 11.9316 2.08146C12.4224 2.35019 12.8376 2.73814 13.1391 3.20955C13.6875 3.08624 14.2583 3.10364 14.7982 3.26015C15.3382 3.41665 15.8298 3.70717 16.2273 4.10468C16.6248 4.50219 16.9153 4.99378 17.0718 5.53372C17.2283 6.07366 17.2457 6.64441 17.1224 7.19289C17.5938 7.49431 17.9818 7.90956 18.2505 8.40035C18.5192 8.89114 18.6601 9.44168 18.6601 10.0012C18.6601 10.5608 18.5192 11.1113 18.2505 11.6021C17.9818 12.0929 17.5938 12.5081 17.1224 12.8096C17.2452 13.3572 17.2277 13.927 17.0716 14.466C16.9154 15.0051 16.6257 15.4961 16.2293 15.8933C15.8329 16.2906 15.3425 16.5813 14.8038 16.7386C14.265 16.8958 13.6953 16.9145 13.1474 16.7929C12.8464 17.2661 12.4308 17.6557 11.9392 17.9257C11.4475 18.1956 10.8957 18.3371 10.3349 18.3371C9.77404 18.3371 9.22225 18.1956 8.73062 17.9257C8.23899 17.6557 7.82343 17.2661 7.52239 16.7929C6.97475 16.9157 6.40498 16.8982 5.8659 16.7421C5.32682 16.5859 4.83588 16.2962 4.43862 15.8998C4.04135 15.5034 3.75061 15.013 3.59336 14.4743C3.4361 13.9355 3.41743 13.3658 3.53906 12.8179C3.06402 12.5173 2.67274 12.1014 2.4016 11.6089C2.13046 11.1164 1.98828 10.5634 1.98828 10.0012C1.98828 9.43905 2.13046 8.88601 2.4016 8.39354C2.67274 7.90108 3.06402 7.48518 3.53906 7.18455Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12.832 7.5L7.83203 12.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M7.83203 7.5H7.84036" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12.832 12.5H12.8404" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
      {label}
    </p>

    <h3 className={`text-7xl font-bold mb-2 ${highlight ? "text-[#012E2F]" : "text-white"}`}>
      {price}
    </h3>

    <p className={`${highlight ? "text-gray-700 text-sm" : "text-white/70 text-sm"} mb-6`}>{per}</p>
    <a className="w-full" href="#heroSection">
      <button className="w-full py-3 bg-[#0b2b40] text-white font-semibold rounded-full hover:opacity-90 transition flex gap-8 items-center justify-between px-4">
      <span>Zum Lösch-Assistent</span>
      <span className="bg-white text-gray-900 p-1 rounded-full flex items-center justify-center">
        <HiArrowRight className="text-lg transform -rotate-24" />
      </span>
    </button>
    </a>

  </div>
);

export default Packages;
